import type { ReactNode } from "react";
import { SearchResultCard } from "./";
import { routesConfig } from "config/app-config";
import type { Personne } from "models";
import PersonIcon from "@mui/icons-material/Person";
import HigherMandatsSubtitle from "components/Elus/HigherMandatsSubtitle";
import type { FuseResultMatch } from "fuse.js";
import { elusService } from "services";
import useSWR from "swr";
import { createSwrConfiguration } from "utils";

interface EluSearchResultCardProps {
  elu: Personne;
  name: string;
  matches?: ReadonlyArray<FuseResultMatch>;
}

/**
 * Affiche une Card représentant le résultat de la recherche.
 * @param elu Personne
 * @param name string
 */
export function EluSearchResultCard({
  elu,
  name,
  matches,
}: Readonly<EluSearchResultCardProps>): ReactNode {
  const {
    data: fullElu,
    isLoading,
    error,
  } = useSWR(
    `/elus/${elu.id}`,
    async () => elusService.getPersonneById(elu.id),
    createSwrConfiguration()
  );

  return (
    <SearchResultCard
      icon={<PersonIcon />}
      name={name}
      url={routesConfig.elu.getParameterPath(elu.id)}
      type={elu.sexe === "F" ? "Élue" : "Élu"}
      subtitle={<HigherMandatsSubtitle elu={fullElu} error={error} isLoading={isLoading} noLink />}
      matches={matches}
    />
  );
}
